import { audioContextSlice } from "./slice";

export const { initAudioContext } = audioContextSlice.actions;
